import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useState } from 'react';
import { Icon } from '@gravity-ui/uikit';
import { Status } from '../../types';
import { block } from '../../utils/cn';
import { MarkItem } from './MarkItem';
import i18n from './i18n';
import irrelevantIcon from '../../assets/icons/dislike';
import vitalIcon from '../../assets/icons/like';
import './Marks.css';
import { jsx as _jsx } from "react/jsx-runtime";
var b = block('marks');
var MARKS = {
  irrelevant: irrelevantIcon,
  vital: vitalIcon
};
export function Marks(_ref) {
  var onItemClick = _ref.onItemClick,
    className = _ref.className;
  var _useState = useState(Status.IDLE),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  var onItemClickCallback = useCallback(function (mark) {
    setStatus(Status.FINISHED);
    onItemClick === null || onItemClick === void 0 || onItemClick(mark);
  }, [onItemClick]);
  return /*#__PURE__*/_jsx("div", {
    className: b(null, className),
    children: status === Status.FINISHED ? i18n('thanks') : Object.entries(MARKS).map(function (_ref2, index) {
      var _ref3 = _slicedToArray(_ref2, 2),
        mark = _ref3[0],
        iconSvg = _ref3[1];
      var icon = /*#__PURE__*/_jsx(Icon, {
        data: iconSvg,
        size: 14
      });
      return /*#__PURE__*/_jsx(MarkItem, {
        icon: icon,
        mark: mark,
        className: b('item'),
        onClick: onItemClickCallback
      }, index);
    })
  });
}
// #sourceMappingURL=Marks.js.map